import styled, { keyframes } from 'styled-components';

interface Props {
	$size?: number;
	$isNormal?: boolean;
}

const loaderRotate = keyframes`
	0% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(360deg);
	}
`;

const LoadingContainer = styled.div`
	width: 100%;
	padding: 20px;
	text-align: center;
`;

export default styled.div<Props>`
	width: ${(props) => props.$size || 56}px;
	height: ${(props) => props.$size || 56}px;
	border: ${(props) => (props.$size || 56) / 7}px solid rgba(0, 0, 0, 0.07);
	border-top-color: ${(props) => (props.$isNormal ? '#393969' : '#fff')};
	border-radius: 50%;
	position: relative;
	animation: ${loaderRotate} 1s linear infinite;
	display: inline-block;
`;

export { LoadingContainer };
